// Open dialogs, oldest first. One shared Escape listener closes only the
// topmost, so a dialog opened over another does not take its parent with it.
const stack = [];

// pushModal registers an open dialog; remove drops it when it unmounts.
export const pushModal = (close) => {
  const entry = { close };
  stack.push(entry);
  return {
    remove: () => {
      const i = stack.indexOf(entry);
      if (i >= 0) stack.splice(i, 1);
    },
  };
};

// handleEscape closes the topmost dialog; true when it did.
export const handleEscape = (e) => {
  if (e.key !== "Escape" || stack.length === 0) return false;
  stack[stack.length - 1].close();
  return true;
};
